var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-6 offset-xl-3"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Pagina non trovata")])]),_vm._v(" "),_c('p',[_vm._v("La pagina che stai cercando non esiste.")])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-707de114","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GeneralViews/NotFoundPage.vue
// module id = 4GcF
// module chunks = 2